// dewu.js
import service from './api';

const ACCESS_TOKEN = '9J3-XlCd1VI6HyvRkUdMCcdppanxteHTf9wgW0-CKdM';

export function searchDewuByPic(picUrl, wxLoginToken) {
    return service.post('/sys/base/searchDewuByPic', {
        picUrl,
        limit: 5,
        wxLoginToken
    });
}

/**
 * common/h5/applet/dress-up/feed 接口封装
 * @param {string} wxLoginToken 用户登录 token
 * @param {number|string} productId 商品ID
 * @returns {Promise<Object>} 接口返回数据
 */
export function commonH5AppletDressUpFeed(wxLoginToken, productId) {
    return service.post('/sys/sell/commonDewuH5Method', {
        ip: '',
        port: '',
        method: 'post',
        url: 'https://app.dewu.com/sns-rec/v1/common/h5/applet/dress-up/feed',
        firstSpuId: 0,
        limit: 20,
        source: 0,
        productId: productId,
        v: '5.73.0',
        platform: 'h5',
        abField: {
            ab572ConsoleGame: '1'
        },
        wxLoginToken: wxLoginToken
    });
}


/**
 * poizon 分销商品查询接口
 * @param {Array<number>} dwSpuIdList spuId 数组
 * @returns {Promise<Object>} 接口返回数据
 */
export function querySpuList(dwSpuIdList) {
    return service.post(
        'https://distopen.poizon.com/open/api/v1/distribute/product/querySpuList',
        { dwSpuId: dwSpuIdList },
        {
            headers: {
                'access-token': ACCESS_TOKEN,
                'Content-Type': 'application/json'
            }
        }
    );
}



/**
 * 货号回传接口
 * @param {string} number - 商品货号
 * @param {string} type - '单货号' 或 '多货号'
 */
export function sendNumberBack(number, type) {
    return service.post('/sys/sell/commonPost', {
        url: "https://www.dedlion.com/api/workflow/hooks/NjkyNWJmZThmMTY0MTAwNzk2YjAzZjUy",
        number,
        type
    }, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
}

/**
 * 获取明道云 worksheet 首条记录的 tp_ys_ 的 DownloadUrl
 * @returns {Promise<string|null>} 返回图片 DownloadUrl 或 null
 */
export async function getFirstDownloadUrl() {
    try {
        const res = await service.post('/sys/sell/commonPost', {
            appKey: "681a78e1b8c72330",
            "url":"https://www.dedlion.com/api/v2/open/worksheet/getFilterRows",
            sign: "M2NkZGZiMmM5OWIyMTUxMDQ4N2Y2YTAwZTMxNDJmM2Q3NWI5ZmU4MGU4ZDcxZjlhYWI1ZTUyOWJmNDgxYWU2OQ==",
            worksheetId: "sjclb",
            viewId: "6909529dbe2ffd8cd2aff9e7",
            pageSize: 1,
            pageIndex: 1
        }, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const rows = res?.data?.rows;
        if (!rows || !rows.length) return null;

        const firstRow = rows[0];
        const tpYs = firstRow?.tp_ys_;
        if (!tpYs) return null;

        let files = [];
        try {
            files = JSON.parse(tpYs);
        } catch (e) {
            console.error('tp_ys_ JSON 解析失败:', e);
            return null;
        }

        if (!Array.isArray(files) || !files.length) return null;
        return files[0].DownloadUrl || null;

    } catch (e) {
        console.error('获取明道云图片失败:', e);
        return null;
    }
}



/**
 * 获取明道云 worksheet 首条记录的 tp_ys_ 的 DownloadUrl 和 hh_ys_ 的货号
 * @returns {Promise<{downloadUrl: string|null, hh: string|null}|null>} 返回对象或 null
 */
export async function getFirstDownloadUrlAndHh() {
    try {
        const res = await service.post('/sys/sell/commonPost', {
            appKey: "681a78e1b8c72330",
            url: "https://www.dedlion.com/api/v2/open/worksheet/getFilterRows",
            sign: "M2NkZGZiMmM5OWIyMTUxMDQ4N2Y2YTAwZTMxNDJmM2Q3NWI5ZmU4MGU4ZDcxZjlhYWI1ZTUyOWJmNDgxYWU2OQ==",
            worksheetId: "sjclb",
            viewId: "6909529dbe2ffd8cd2aff9e7",
            pageSize: 1,
            pageIndex: 1
        }, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        const rows = res?.data?.rows;
        if (!rows || !rows.length) return null;

        const firstRow = rows[0];

        // 处理图片字段 tp_ys_
        let downloadUrl = null;
        const tpYs = firstRow?.tp_ys_;
        if (tpYs) {
            try {
                const files = JSON.parse(tpYs);
                if (Array.isArray(files) && files.length) {
                    downloadUrl = files[0].DownloadUrl || null;
                }
            } catch (e) {
                console.error('tp_ys_ JSON 解析失败:', e);
            }
        }

        // 直接获取 hh_ys_ 字段
        const hh = firstRow?.hh_ys_ || null;

        const title = firstRow?.bt_ys_ || null;

        const color = firstRow?.ys_ys_ || null;

        const cate = firstRow?.pl_ys_ || null;

        return { downloadUrl, hh, title,color,cate };

    } catch (e) {
        console.error('获取明道云数据失败:', e);
        return null;
    }
}